import React, { useEffect, useState } from "react";
import { Modal, Accordion, Card, Button, Dropdown } from "react-bootstrap";
import { getPolicyById, togglePolicyVisibility } from "../../../config/services/employeeServices";
import ResponseFilter from "../../../ResponseFilter";
import { Loader } from "../../svg";
import "./ViewPolicyHistoryModal.css";
import DOMPurify from 'dompurify';

import ViewUploadedPdf from "./ViewUploadedPdf";

const ViewPolicyHistoryModal = (props) => {
    const { show, closeModal, policyId } = props;
    const [loading, setLoading] = useState(false);
    const [historyList, setHistoryList] = useState([]);
    const isAdmin = parseInt(localStorage.getItem("isAdmin"));

    const [openViewDoc, setOpenViewDoc] = useState(false);
    const [selectedDoc, setSelectedDoc] = useState("");

    const [openDescModal, setOpenDescModal] = useState(false);
    const [descContent, setDescContent] = useState("");

    useEffect(() => {
        if (show && policyId) {
            fetchPolicyDetails();
        } else {
            setHistoryList([]);
        }
    }, [show, policyId]);

    const fetchPolicyDetails = () => {
        setLoading(true);
        getPolicyById({ policyId })
            .then((res) => {
                const { status, resData } = ResponseFilter(res);
                if (status && resData && resData.list && resData.list.length > 0) {
                    const currentPolicy = resData.list[0];
                    const pastVersions = currentPolicy.versions || [];

                    // Create list including current and past versions
                    let combinedList = [
                        { ...currentPolicy, isCurrent: true },
                        ...pastVersions.map(v => ({ ...v, isCurrent: false }))
                    ];

                    // Sort descending by version
                    combinedList.sort((a, b) => {
                        const vA = a.version ? a.version.split('.').map(Number) : [0, 0];
                        const vB = b.version ? b.version.split('.').map(Number) : [0, 0];
                        if (vA[0] !== vB[0]) return vB[0] - vA[0];
                        return vB[1] - vA[1];
                    });

                    setHistoryList(combinedList);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setLoading(false);
                setHistoryList([]);
            });
    };

    const handleViewDescription = (description) => {
        setDescContent(description || "No description provided.");
        setOpenDescModal(true);
    };

    const handleToggleVisibility = (item) => {
        const params = {
            isHidden: !item.isHidden
        };
        if (item.isCurrent) {
            params.privacyId = item._id;
        } else {
            params.versionId = item._id;
        }

        setLoading(true);
        togglePolicyVisibility(params)
            .then((res) => {
                fetchPolicyDetails();
            })
            .catch((err) => {
                console.error(err);
                setLoading(false);
            });
    };


    return (
        <>
            <Modal
                show={show}
                onHide={closeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="view-policy-history-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Policy Version History
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px", position: "relative" }}>
                            <Loader small={true} />
                        </div>
                    ) : (
                        <div className="history-list">
                            {historyList.length > 0 ? (
                                historyList.map((item, index) => (
                                    <Card key={index} className="mb-2 shadow-sm">
                                        <Card.Body className="p-3 d-flex justify-content-between align-items-center">
                                            <div style={{ flex: 1 }}>
                                                <div className="d-flex align-items-center mb-1">
                                                    <h6 className="mb-0 font-weight-bold mr-2">Version {item.version}</h6>
                                                    {item.isCurrent && <span className="badge badge-success mr-2">Latest</span>}
                                                    {item.isHidden && <span className="badge badge-warning">Hidden</span>}
                                                </div>

                                                <div className="small text-muted mb-1">
                                                    <i className="fa fa-calendar mr-1"></i>
                                                    <strong>Created: </strong>
                                                    {new Date(item.created || item.createdAt).toLocaleDateString()}
                                                </div>
                                                <div className="small text-dark">
                                                    <strong>Title: </strong> {item.title} <span className="mx-2">|</span> <strong>Department: </strong> {item.department || "General"}
                                                </div>
                                            </div>
                                            <div className="ml-3 d-flex align-items-center">
                                                {item.description && item.description.replace(/<[^>]*>/g, '').trim().length > 0 && (
                                                    <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        onClick={() => handleViewDescription(item.description)}
                                                        className="mr-2"
                                                    >
                                                        <i className="fa fa-eye mr-1"></i> View Text
                                                    </Button>
                                                )}

                                                {item.docLink && (
                                                    <Button
                                                        variant="outline-info"
                                                        size="sm"
                                                        onClick={() => {
                                                            setSelectedDoc(item.docLink);
                                                            setOpenViewDoc(true);
                                                        }}
                                                        className="mr-2"
                                                    >
                                                        <i className="fa fa-file-text mr-1"></i> View Doc
                                                    </Button>
                                                )}

                                                {(isAdmin === 1 || isAdmin === 4) && (
                                                    <Dropdown align="end">
                                                        <Dropdown.Toggle variant="link" id={`dropdown-basic-${index}`} className="p-0 text-muted shadow-none no-caret">
                                                            <i className="fa fa-ellipsis-v"></i>
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu>
                                                            <Dropdown.Item onClick={() => handleToggleVisibility(item)}>
                                                                {item.isHidden ? (
                                                                    <><i className="fa fa-eye mr-2 text-success"></i> Unhide Version</>
                                                                ) : (
                                                                    <><i className="fa fa-eye-slash mr-2 text-danger"></i> Hide Version</>
                                                                )}
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                )}
                                            </div>

                                        </Card.Body>
                                    </Card>
                                ))
                            ) : (
                                <p className="text-center text-muted">No history available.</p>
                            )}
                        </div>
                    )}
                </Modal.Body>
            </Modal>

            {/* Description Modal */}
            <Modal
                show={openDescModal}
                onHide={() => setOpenDescModal(false)}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Policy Description</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="policy-description-content" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(descContent) }} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setOpenDescModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <ViewUploadedPdf
                show={openViewDoc}
                doc={selectedDoc}
                closeModal={() => setOpenViewDoc(false)}
            />
        </>
    );
};

export default ViewPolicyHistoryModal;
